import React, { useContext, useEffect, useRef } from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import gsap from 'gsap';

import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import ModalHeader from 'components/FiltersModal/Header';
import { Constrain } from 'components/FiltersModal/components';
import Offers from 'components/TargetedOffers/Offers';
import CustomFilters from '../CustomFilters';
import { CONTAINERS } from 'contexts/CruiseSearchContext/constants';

import { useFeatureFlags } from '../../../../hooks/LaunchDarkly/useFeatureFlags';

const QualifiersWrapper = styled.div``;

/**
 * Qualifiers
 *
 * The Qualifiers slide listens to/set the qualifiers search query.
 */

function Qualifiers() {
	const { updateQualifiersSelecting, globalization, filterOptionsDictionary } = useContext(CruiseSearchContext);
	const { enableTargetedOffersFeature, showMyOffers } = useFeatureFlags();

	const { filtersDictionary } = globalization?.dictionaries || {};
	const { navMyOffers, labelCurrentOffers } = filtersDictionary;

	const wrapperRef = useRef();
	/**
	 * MOUNT
	 * Animate in
	 */
	useEffect(() => {
		gsap.to(wrapperRef.current, {
			opacity: 1,
			x: 0,
			duration: 0.5,
			delay: 0.1,
			ease: 'cubic-bezier(0,0,0,0)',
		});
		gsap.to(wrapperRef.current?.children || [], {
			opacity: 1,
			x: 0,
			duration: 0.35,
			stagger: 0.05,
			delay: 0.1,
			ease: 'cubic-bezier(0,0,0,0)',
		});
	}, []);

	const hasCurrentOffers = () => {
		const { custom = [] } = filterOptionsDictionary || {};

		return custom?.options?.flatMap(option => option.containers)?.includes(CONTAINERS.FILTER_MY_OFFERS) && showMyOffers;
	};

	/**
	 * This is going to change!
	 * Waiting to be unblocked by RCCL dev team
	 * Also need to know where/how we are getting the labels
	 */
	return (
		<>
			<ModalHeader title={navMyOffers} onReset={() => updateQualifiersSelecting([])} />
			{hasCurrentOffers() && <CustomFilters title={labelCurrentOffers} keyName={CONTAINERS.FILTER_MY_OFFERS} />}
			<Constrain className="no-top-padding">
				<QualifiersWrapper>{enableTargetedOffersFeature && <Offers />}</QualifiersWrapper>
			</Constrain>
		</>
	);
}

Qualifiers.propTypes = {};

export default Qualifiers;
